import { defineMessage } from 'services/localization';

export const messages = {
    activeTemplateNotFound: defineMessage('active_template_not_found'),
    errorWhileFetching: defineMessage('error_while_fetching_workflow_with_certain_version'),
};
